import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogBase} from "app/archivage/deposit/modal/dialog.base";
import {MagasinService} from "app/archivage/common/services/magasin/magasin.service";
import {Observable} from "rxjs";
import {Pagination} from "@Common/widgets/general/pagination";

@Component({
  selector: 'app-dialog-archived',
  templateUrl: './dialog-archived.component.html',
  styleUrls: ['./dialog-archived.component.scss']
})
export class DialogArchivedComponent extends DialogBase<DialogArchivedComponent> implements OnInit {
  magasins$: Observable<Pagination>;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<DialogArchivedComponent>,
              private magasinSvc: MagasinService,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);
  }

  _initForm(): void {
    this.dialogForm = this.formBuilder.group({
      mag: ['', [Validators.required]],
      epi: ['', [Validators.maxLength(16)]],
      tra: ['', [Validators.required, Validators.maxLength(16)]],
      ray: ['', [Validators.required, Validators.maxLength(16)]],
      tab: ['', [Validators.required, Validators.maxLength(16)]],
    });
    this.magasins$ = this.magasinSvc.listAllItems();
  }
}
